import React from "react";
import Sidebar from "./Sidebar";
import { Card, Col } from "react-bootstrap";
import { FaCogs } from "react-icons/fa";

// import FineTypeBox from "./FineTypeBox"; // Adjust path if needed
  import AppSetupAction from "./AppSetupAction";

const AppSettingPage = () => {
  return (
    <div className="d-flex">
      <Sidebar />
      <div className="content flex-grow-1" style={{
          marginLeft: "280px",
          width: "calc(100% - 280px)",
          padding: "20px",
        }}>
        <div className="container-fluid">
          {/* Page Header */}
          <div className="row mb-4">
            <div className="col-12">
              <h2 className="fw-bold text-primary mb-0">
                <FaCogs className="me-2" />
                App Settings
              </h2>
              <p className="text-muted">
                <b>Configure application-wide settings and preferences</b>
              </p>
            </div>
          </div>
          {/* Settings Cards */}
          <div className="row">
            {/* <Col md={6} className="mb-3">
              <Card className="shadow-sm border-0">
                <Card.Body>
                  <h5 className="fw-bold mb-3">Fine Type</h5>
                  <Col md={6} className="mb-3">
                    <FineTypeBox />
                  </Col>
                </Card.Body>
              </Card>
            </Col> */}
            <Col md={6} className="mb-3">
              <Card className="shadow-sm border-0">
                <Card.Body>
                  <h5 className="fw-bold mb-3"> App Rules </h5>
                  <AppSetupAction />
                </Card.Body>
              </Card>
            </Col>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppSettingPage;
